export const getAndSetDefault = <K, V>(map: Map<K, V>, key: K, defaultValue: V): V =>
  map.get(key) ?? (map.set(key, defaultValue), defaultValue);

/**
 * keep in mind that the setter can receive an `undefined` value if there was none to begin with in the map
 * at the given key – checking for situations like that in the setter lets you define a default
 */
export const updateWith = <K, V>(map: Map<K, V>, key: K, setter: (value?: V) => V) =>
  map.set(key, setter(map.get(key)));
